import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useEffect, useState } from "react";

const Product = () => {
  const productList = [
    {
      id: 1,
      name: "케냐 Top/AA",
      country: "Kenya/Karatine/1,900m",
      detail:
        "첫 맛은 강하나, 중간 맛은 레몬그라스향과 베르가못의 잔잔함을<br/>끝맛은 강한 와인 맛의 여운을 주는 커피",
      target: "상큼하고 화사한 커피 선호하는 소비자",
      image: "/images/product10.png",
    },
    {
      id: 2,
      name: "코스타리카 따라주",
      country: "Costarica/Tarrazu/1,200 ~ 1,800m",
      detail:
        "화산지대의 산뜻하고 가벼운 신맛을 가지고 있으며, 은은한 초콜릿 향을 머금어 고소한 맛에 집중되는 밝은 맛의 결정체",
      target: "밸런스 좋은 커피를 선호하는 소비자",
      image: "/images/product8.png",
    },
    {
      id: 3,
      name: "인도네시아 만델링G1",
      country: "Indonesia/Sumatra/1,200 ~ 1,500m",
      detail: "묵직한 바디감과 중후함,<br/>다크초콜릿이 연상되는 커피",
      target: "진하고 깊은 맛을 좋아하는 소비자",
      image: "/images/product5.png",
    },
    {
      id: 4,
      name: "과테말라 안티구아",
      country: "Guatemala/Antigua/1,400 ~1,600m",
      detail:
        "초콜릿 향, 낙엽 탄 듯한 맛, 스파이시, 숙성된 와인 향까지<br/>가장 다양한 맛을 가진 커피",
      target: "묵직하고 고급스러운 풍미 선호하는 소비자",
      image: "/images/product4.png",
    },
    {
      id: 5,
      name: "에티오피아 예가체프",
      country: "Ethiopia/Yirgacheffe/1,770 ~ 2,200m",
      detail: "가벼운 바디감과 시트러스한 과일 맛, 꽃향기가 어우러진 커피",
      target: "향 중심, 화사한 향미를 즐기는 소비자",
      image: "/images/product3.png",
    },
    {
      id: 6,
      name: "데스타",
      country: "서아프리카에 위치한 라이베리아 원산지",
      detail:
        "첫 맛은 베리와 과일꽃 향, 중간 맛은 향신료 풍미와 스모키함, 끝 맛은 견과류의 고소함과 다크초콜릿을 연상캐 한다",
      target: "“한국에서 맛보기 어려운 독점급 포지션”으로 차별화 가능",
      image: "/images/product4.png",
    },
  ];

  const [count, setcount] = useState(1);

  useEffect(() => {
    // handleResize 함수 정의: 창 크기가 특정 조건을 충족할 때 애니메이션을 실행하는 역할
    const handleResize = () => {
      if (window.innerWidth > 1080) {
        // 창의 너비가 1080px보다 클 때
        setcount(5);
      } else {
        setcount(1);
      }
    };

    // 처음 컴포넌트가 마운트될 때 handleResize 함수를 한 번 실행
    handleResize();

    // 창 크기가 변경될 때마다 handleResize 함수를 실행
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <div id="product" className=" relative w-full h-full">
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] py-14 xl:py-28 bg-grayy">
        <div id="title">
          <h3 className="text-point mb-5">Single Origin Line</h3>
          <p>✔ 최고의 품질 Grade 1 이상의 생두로 로스팅한 싱글 오리진</p>
          <p>✔ 세계적으로 소량만 생산되어 구하기 힘든 생두</p>
          <p>✔ 35년 경력의 마스터를 통해 최상의 맛을 이끌어 낸 싱글 오리진</p>
        </div>
        <div data-aos="fade-up" className=" relative w-full h-full mt-14">
          <Swiper
            spaceBetween={20}
            loop={true}
            slidesPerView={count}
            autoplay={{
              delay: 5500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={1500}
            modules={[Autoplay, Pagination, Navigation]}
            className="swiper relative w-full h-fit"
          >
            {productList.map((v, i) => (
              <SwiperSlide key={i}>
                <div className=" relative w-full h-full">
                  <div className=" relative w-full h-fit">
                    <img
                      className="!relative w-full h-full object-cover object-center"
                      src={v.image}
                      alt="product"
                      width={616}
                      height={880}
                    />
                  </div>
                  <div className="relative w-full h-full text-center pr-3 grid grid-rows-3">
                    <div className="py-3">
                      <p className="text-point">{v.name}</p>
                      <p className="text-xs">{v.country}</p>
                      <div className="pt-3 border-b-2 w-8 mx-auto border-gray-400"></div>
                    </div>
                    <p
                      className="text-sm"
                      dangerouslySetInnerHTML={{ __html: v.detail }}
                    ></p>
                    <div>
                      {/* <p className="text-sm">고객층</p> */}
                      <p className="text-sm text-point">{v.target}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* <div className=" relative w-full h-full mt-14 grid xl:grid-cols-2 gap-5">
          <div
            data-aos="fade-right"
            className=" relative w-full h-full p-5 border rounded-sm border-blue-400 xl:hover:-translate-y-5 transition-all duration-300"
          >
            <h4 className="mb-5">Single Origin Line</h4>
            <p>✔ 최고의 품질 Grade 1 이상의 생두로 로스팅한 싱글 오리진</p>
            <p>✔ 세계적으로 소량만 생산되어 구하기 힘든 생두</p>
            <p>✔ 35년 경력의 마스터를 통해 최상의 맛을 이끌어 낸 싱글 오리진</p>
          </div>
          <div
            data-aos="fade-left"
            className=" relative w-full h-full p-5 border rounded-sm border-orange-300 xl:hover:-translate-y-5 transition-all duration-300"
          >
            <h4 className="mb-2">Blend Line (O&M제품)</h4>
            <h5>1. Special Blend Line</h5>
            <h5 className="mb-3">2. GB Explorer Blend Line</h5>
            <p>✔ 35년 경력 동안 쌓은 프로파일링으로 만든 블렌딩 원두</p>
            <p>✔ Sarah Choi 만의 연구를 통해 나오는 최상의 맛</p>
            <p>✔ 본연의 품종에 맛을 살려 내고 맛을 더욱더 보완하는 노하우를 통한 블랜딩 원두</p>
          </div>
        </div> */}
      </div>
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] py-14 xl:py-28">
        <div id="title">
          <h3 className="text-point mb-2">Blend Line (O&M제품)</h3>
          <h5>1. Special Blend Line</h5>
          <h5 className="mb-3">2. GB Explorer Blend Line</h5>
          <p>✔ 35년 경력 동안 쌓은 프로파일링으로 만든 블렌딩 원두</p>
          <p>✔ Sarah Choi 만의 연구를 통해 나오는 최상의 맛</p>
          <p>
            ✔ 본연의 품종에 맛을 살려 내고 맛을 더욱더 보완하는 노하우를 통한
            블랜딩 원두
          </p>
        </div>
        <div
          // data-aos="fade-up"
          className=" relative w-full h-full mt-14 grid xl:grid-cols-5"
        >
          <div className=" relative w-full h-full">
            <div className=" relative w-fit h-fit">
              <img
                src="images/product13.png"
                alt="product"
                width={616}
                height={880}
              />
            </div>
            <div className="relative w-full h-full text-center pr-3">
              <div className="py-3">
                <p className="text-point">HOUSE BLEND</p>
                <div className="pt-2 border-b-2 w-5 mx-auto border-point"></div>
              </div>
              <p className="text-sm">Well balanced 한 브랜딩 원두</p>
              <p className="text-sm">
                소비자의 성향에 맞추어 커스터마이즈 가능
              </p>
            </div>
          </div>
          {/* <Swiper
            spaceBetween={20}
            loop={true}
            slidesPerView={count}
            autoplay={{
              delay: 5500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            speed={1500}
            modules={[Autoplay, Pagination, Navigation]}
            className="swiper relative w-full h-fit"
          >
            {productList.map((v, i) => (
              <SwiperSlide key={i}>
                <div className=" relative w-full h-full">
                  <div className=" relative w-full h-fit">
                    <img
                      className="!relative w-full h-full object-cover object-center"
                      src={v.image}
                      alt="product"
                      width={616}
                      height={880}
                    />
                  </div>
                  <div className="relative w-full h-full text-center pr-3">
                    <div className="py-3">
                      <p className="text-point">{v.name}</p>
                      <div className="pt-2 border-b-2 w-5 mx-auto border-point"></div>
                    </div>
                    <p className="text-sm">{v.detail}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper> */}
        </div>
      </div>
    </div>
  );
};

export default Product;
